import styles from "./style.module.scss";

import { useState, useEffect, useRef } from "react";
import Layout from "../../../components/layout";
import { adminService } from "../../../api/admin";
import { useParams } from "react-router-dom";

export default function InspectorUsersView() {
  const [users, setUsers] = useState();
  const [pagination, setPagination] = useState(0);
  const [pages, setPages] = useState(null);
  const [error, setError] = useState(null);
  const [forceReload, setForceReload] = useState(false);

  const { role, idParent } = useParams();
  const defaultSearch = useRef();

  let token = localStorage.getItem("token");
  let numberPerPage = 200;

  //--- ---

  const loadUsersForInspector = (defaultSearch = "", tutorId = 0) => {
    let idParent = 0;
    if (tutorId > 0 && defaultSearch === "") {
      idParent = tutorId;
    }

    let params = {
      token: token,
      page: pagination,
      idParent: idParent || 0,
      defaultSearch: defaultSearch,
    };
    adminService
      .getUsersForInspector(params)
      .then((response) => {
        setUsers(response?.data?.payload?.data);
        if (response?.data?.payload?.count) {
          setPages(Math.ceil(response?.data?.payload?.count / numberPerPage));
        }
      })
      .catch((error) => {
        setUsers([]);
        setPages(null);
      });
  }; //loadUsersForInspector

  useEffect(() => {
    loadUsersForInspector();
    // eslint-disable-next-line
  }, [
    setUsers,
    setPagination,
    pagination,
    role,
    idParent,
    forceReload,
  ]);

  const nextPage = () => {
    setPagination(pagination + 1);
  };

  const prevPage = () => {
    setPagination(pagination - 1);
  };

  let arr = [];

  const getPagination = () => {
    if (pages) {
      for (let i = 1; i <= pages; i++) {
        arr.push(i);
      }
      return arr;
    }
  };

  const goToPage = (item) => {
    setPagination(item - 1);
  };

  const goToSearch = () => {
    loadUsersForInspector(defaultSearch.current.value, 0);
    defaultSearch.current.value = "";
  }; //goToSearch

  //---

  return (
    <>
      <Layout>
        <div className="mx-auto">
          <div>
            <label
              htmlFor="default-search"
              className="mb-2 text-sm font-medium text-gray-900 sr-only dark:text-white">
              Search
            </label>
            <div className="relative mb-4 flex gap-2">
              <div className="absolute inset-y-0 left-0 flex items-center pl-3 pointer-events-none">
                <svg
                  aria-hidden="true"
                  className="w-5 h-5 text-gray-500 dark:text-gray-400"
                  fill="none"
                  stroke="currentColor"
                  viewBox="0 0 24 24"
                  xmlns="http://www.w3.org/2000/svg">
                  <path
                    strokeLinecap="round"
                    strokeLinejoin="round"
                    strokeWidth="2"
                    d="M21 21l-6-6m2-5a7 7 0 11-14 0 7 7 0 0114 0z"></path>
                </svg>
              </div>
              <input
                type="search"
                id="default-search"
                ref={defaultSearch}
                onKeyDown={(e) => {
                  if (e.key === "Enter") {
                    goToSearch();
                  }
                }}
                className={`w-2/3 p-4 pl-10 text-md text-gray-900 border border-gray-300 rounded-lg bg-gray-50 focus:ring-blue-500 focus:border-blue-500 dark:bg-gray-700 dark:border-gray-600 dark:placeholder-gray-400 dark:text-white dark:focus:ring-blue-500 dark:focus:border-blue-500`}
                placeholder="cognome"
              />

              <button
                type="submit"
                onClick={(e) => {
                  goToSearch();
                }}
                className="w-1/3 p-4 text-md text-white rounded-lg bg-blue-700 hover:bg-blue-800 focus:ring-blue-500 focus:border-blue-500 dark:bg-gray-700 dark:border-gray-600 dark:placeholder-gray-400 dark:text-white dark:focus:ring-blue-500 dark:focus:border-blue-500 uppercase">
                cerca
              </button>
            </div>
          </div>

          {/**************************/}

          <table className="w-full border-collapse border border-slate-500 text-left">
            <thead>
              <tr>
                <th className="border border-slate-600 p-2">Nome</th>
                <th className="border border-slate-600 p-2 ">Cognome</th>
                <th className="border border-slate-600 p-2 ">Codice Corso</th>
                <th className="border border-slate-600 p-2 ">Data inizio</th>
                <th className="border border-slate-600 p-2 ">Data fine</th>
              </tr>
            </thead>
            <tbody>
              {users?.map((item, index) => (
                <tr key={index} className="even:bg-gray-70 odd:bg-white">
                  <td className="border border-slate-700 p-2 py-4 ">
                  {item?.name}
                  </td>
                  <td className="border border-slate-700 p-2 py-4 ">
                    {item?.surname}
                  </td>
                  <td className="border border-slate-700 p-2 py-4 ">{item?.courseCode}</td>
                  <td className="border border-slate-700 p-2 py-4 ">{item?.startedAt}</td>
                  <td className="border border-slate-700 p-2 py-4 ">{item?.endedAt || item?.status}</td>
                </tr>
              ))}
            </tbody>
          </table>

          <div className={`${styles.pagination} flex flex-wrap justify-center`}>
            {pages !== null && (
              <div className="cursor-pointer" onClick={() => prevPage()}>
                Indietro
              </div>
            )}

            {getPagination()?.map((item, index) => (
              <div
                className={`${styles.pageNumber} ${
                  pagination === index ? styles.pageActive : ""
                }`}
                onClick={() => goToPage(item)}
                key={index}>
                {item}
              </div>
            ))}

            {pages !== null && (
              <div className="cursor-pointer" onClick={() => nextPage()}>
                Avanti
              </div>
            )}
          </div>
        </div>
      </Layout>
    </>
  );
}
